class FlashMessageStorage
{
    constructor(standardFlashTimeout = 3000, minimalFlashTimeout = 0, immediatelyOverride = false)
    {
        this.flashingMessage = null
        this.messages = []
        this.callback = null
        this.timeout = null
        this.immediatelyOverride = immediatelyOverride
        if (minimalFlashTimeout === 0) {
            minimalFlashTimeout = standardFlashTimeout
        }
        if (minimalFlashTimeout > standardFlashTimeout) {
            standardFlashTimeout = minimalFlashTimeout
        }
        this.minimalFlashTimeout = minimalFlashTimeout
        this.minimalToStandardTimeout = standardFlashTimeout - minimalFlashTimeout
    }

    setCallback(callback)
    {
        if (callback !== this.callback) {
            this.callback = callback
            this.notify()
        }
    }

    putMessage(message, type, undoAction=null)
    {
        const msg = {message, type, undoAction}
        this.messages.push(msg)
        if (this.flashingMessage === null || this.immediatelyOverride) {
            this.setNextMessage()
        }
    }

    setNextMessage()
    {
        if (this.timeout !== null) {
            clearTimeout(this.timeout)
            this.timeout = null
        }
        if (this.messages.length > 0) {
            this.flashingMessage = this.messages.shift()
            this.timeout = setTimeout(() => {
                if (this.messages.length > 0 || this.minimalToStandardTimeout == 0) {
                    this.setNextMessage()
                    this.timeout = null
                } else {
                    this.timeout = setTimeout(() => {
                        this.setNextMessage()
                        this.timeout = null
                    }, this.minimalToStandardTimeout)
                }
            }, this.minimalFlashTimeout)
            this.notify()
        } else if (this.flashingMessage !== null) {
            this.flashingMessage = null
            this.notify()
        }
    }

    notify()
    {
        if (this.callback !== null) {
            this.callback.call(null, this.flashingMessage)
        }
    }
}

export default FlashMessageStorage
